import { apiCall } from './gqlClient';

const GETWEBINTEGRATION_QUERY = `
  query getWebIntegration($id: Int!) {
    getWebIntegration(id: $id)
    {
      id
			background
			base
			body
			button
			font
			fontname
			gradient
			link
			name
			page
			providerId
			integrationType
			url
			integrationCode
      ...fragments
    }
  }`;

export const getWebIntegrationApiCall = async ({id}, fragments = null) => apiCall({ query: GETWEBINTEGRATION_QUERY, variables: {id}, fragments });

const GETALLWEBINTEGRATIONS_QUERY = `
  query getAllWebIntegrations {
    getAllWebIntegrations
    {
      id
			background
			base
			body
			button
			font
			fontname
			gradient
			link
			name
			page
			providerId
			integrationType
			url
			integrationCode
      ...fragments
    }
  }`;

export const getAllWebIntegrationsApiCall = async (fragments = null) => apiCall({ query: GETALLWEBINTEGRATIONS_QUERY, variables: {}, fragments });

const GETLATESTWEBINTEGRATIONWITHPROVIDERID_QUERY = `
  query getLatestWebIntegrationWithProviderId($id: Int!) {
    getLatestWebIntegrationWithProviderId(id: $id)
    {
      id
			background
			base
			body
			button
			font
			fontname
			gradient
			link
			name
			page
			providerId
			integrationType
			url
			integrationCode
      ...fragments
    }
  }`;

export const getLatestWebIntegrationWithProviderIdApiCall = async ({id}, fragments = null) => apiCall({ query: GETLATESTWEBINTEGRATIONWITHPROVIDERID_QUERY, variables: {id}, fragments });

const SAVEWEBINTEGRATION_QUERY = `
  mutation saveWebIntegration($request: WebIntegrationConfigInput!) {
    saveWebIntegration(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const saveWebIntegrationApiCall = async ({request}, fragments = null) => apiCall({ query: SAVEWEBINTEGRATION_QUERY, variables: {request}, fragments });

const DELETEWEBINTEGRATION_QUERY = `
  mutation deleteWebIntegration($id: Int) {
    deleteWebIntegration(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const deleteWebIntegrationApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEWEBINTEGRATION_QUERY, variables: {id}, fragments });
